import { Outlet } from 'react-router-dom'
import { Flex, Layout, theme } from 'antd'

const { Content } = Layout

const AuthLayout: React.FC = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken()

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout className="site-layout">
        <Content
          style={{
            background: '#f8f8f2',
            margin: '0',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            alignContent: 'center',
            justifyItems: 'center',
            padding: 20,
          }}
        >
          <Flex style={{ width: '100%', maxWidth: 350, margin: 'auto' }}>
            <Outlet />
          </Flex>
        </Content>
      </Layout>
    </Layout>
  )
}

export default AuthLayout
